/* <sticky-copy-code> — live's logic (custom.js), de-minified 1:1: reads the
   code from data-code, reserves the bar's height as body padding-bottom (via
   rAF, cleared on disconnect), copies via the async Clipboard API with the
   hidden-textarea execCommand fallback, and swaps the button label for 2s. */

class StickyCopyCode extends HTMLElement {
  connectedCallback() {
    this.code = this.dataset.code;
    this.btn = this.querySelector('.sticky-copy-code__btn');
    this.btnDefault = this.querySelector('.sticky-copy-code__btn-default');
    this.btnCopied = this.querySelector('.sticky-copy-code__btn-copied');

    if (this.btn) {
      this._boundClick = this._onCopy.bind(this);
      this.btn.addEventListener('click', this._boundClick);
    }

    this._adjustBodyPadding();
  }

  disconnectedCallback() {
    if (this.btn && this._boundClick) {
      this.btn.removeEventListener('click', this._boundClick);
    }
    document.body.style.paddingBottom = '';
  }

  _adjustBodyPadding() {
    requestAnimationFrame(() => {
      document.body.style.paddingBottom = this.offsetHeight + 'px';
    });
  }

  _onCopy() {
    if (!this.code) return;

    if (this.btnDefault) this.btnDefault.hidden = true;
    if (this.btnCopied) this.btnCopied.hidden = false;

    clearTimeout(this._resetTimer);
    this._resetTimer = setTimeout(() => {
      if (this.btnDefault) this.btnDefault.hidden = false;
      if (this.btnCopied) this.btnCopied.hidden = true;
    }, 2000);

    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.code).catch(() => this._fallbackCopy());
    } else {
      this._fallbackCopy();
    }
  }

  _fallbackCopy() {
    var textarea = document.createElement('textarea');
    textarea.value = this.code;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
}

if (!customElements.get('sticky-copy-code')) {
  customElements.define('sticky-copy-code', StickyCopyCode);
}
